import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["playlistId"],
  _excluded2 = ["mutateAsync"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { assetQueryKeys } from 'actions/assets';
import { contentQueryKeys } from 'actions/content';
import { playlistQueryKeys } from '.';
export function updatePlaylistContent(playlistId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(content) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('patch', "/api/playlists/".concat(playlistId, "/contents"), null, content));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function useUpdatePlaylistContent(_ref2) {
  var playlistId = _ref2.playlistId,
    options = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: updatePlaylistContent(playlistId)
    }, options), {}, {
      onSuccess: function onSuccess() {
        // We return the invalidation promises here so that we can reset the content manager
        // once loading has finished. (The promises resolve once all queries have refetched.)
        return Promise.all([
        // Invalidate all content-related queries – this makes sure that asset counts
        // in list views are up-to-date and all content changes are shown.
        queryClient.invalidateQueries({
          queryKey: assetQueryKeys.assets
        }), queryClient.invalidateQueries({
          queryKey: playlistQueryKeys.allPlaylists
        }), queryClient.invalidateQueries({
          queryKey: contentQueryKeys.contentLogs()
        })]).then(function () {
          setSuccessAlert({
            title: t('alert_playlist_updated_successfully')
          });
        });
      },
      onError: function onError() {
        setAlert({
          title: t('alert_playlist_not_updated')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updatePlaylistContent: mutateAsync
  });
}
export default useUpdatePlaylistContent;